import { Link } from 'react-router-dom';
import ValuesMarquee from '../components/redesign/ValuesMarquee';
import HeroSection from '../components/HeroSection';
import Footer from '../components/Footer';
import { ContactBanner, ProductsSection, ServicesSection } from '../components/redesign/BusinessSections';
import NewsStrip from '../components/redesign/NewsStrip';
import Reveal from '../components/redesign/Reveal';
import Arrow from '../components/redesign/Arrow';
import WorksGallery from '../components/redesign/WorksGallery';
import EngagementSection from '../components/redesign/EngagementSection';
export default function Home() {
  return <><main id="main-content" tabIndex={-1}><HeroSection /><NewsStrip /><EngagementSection /><ServicesSection /><ProductsSection />
    <section className="home-works section-shell"><Reveal><div className="section-heading"><div><p className="section-label">相談事例・実績</p><h2>相談事例・実績</h2></div><p className="section-intro">AI・Web・インフラ。取り組みの一部をご紹介します。</p></div></Reveal><WorksGallery preview /></section>
    <div className="home-values section-shell"><ValuesMarquee /></div>
    <section className="recruit-band"><div className="section-shell"><Reveal><Link to="/recruit"><div><h2>次をつくる、仲間へ。</h2><p>技術を磨き、可能性をひらく。ともに挑戦しませんか。</p></div><div className="recruit-link">採用情報 <Arrow /></div></Link></Reveal></div></section>
    <ContactBanner /></main><Footer /></>;
}
